import React, { useEffect, useState } from "react";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";
import FileUpload from "../../FileUploadPage/FileUploadPage";
import { Dialog } from "@mui/material";
import ErrorSummary from "../../EmissionLog/ErrorSummary/ErrorSummary";
import { setErrorsByFile } from "../../../services/emissionService";

export const SupplierBulkUpload = () => {
  const [uploadedFiles, setUploadedFiles] = useState<any>(null);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [fileErrors, setFileErrors] = useState<any>(null);

  useEffect(() => {
    if (uploadedFiles) {
      setFileErrors(setErrorsByFile(uploadedFiles));
    }
  }, [uploadedFiles]);

  return (
    <>
      <FileUpload
        typeName="Suppliers"
        setShowErrorDialog={setShowErrorDialog}
        setUploadedFiles={setUploadedFiles}
      ></FileUpload>
      <Dialog
        open={showErrorDialog && fileErrors != null}
        fullWidth
        maxWidth="xl"
      >
        <ErrorSummary setOpen={setShowErrorDialog} fileErrors={fileErrors} />
      </Dialog>
    </>
  );
};
